import React from "react"
import classnames from "classnames"
import { isKeyClick } from "../../scripts/utils"
import { apiAuth } from "../../api"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { default as sharedMessages } from "../../messages/index"
import { default as profileMessages } from "../../messages/profile"
import settingsMessages from "../../messages/settings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { getLayoutType } from "../../scripts/accountSettings"

class ProfileForm extends React.Component {
  state = {
    values: {},
    errors: {},
    notice: "",
    noticeClass: "panel",
    saving: false
  }

  componentDidMount() {
    apiAuth("get", "user").then(values => this.setState({ values }))
  }

  render() {
    const { intl } = this.props
    const { values, errors, notice, noticeClass, saving } = this.state

    const authenticAccountId = intl.formatMessage(
      settingsMessages.authenticAccountId
    )

    return (
      <div className="max-width-area">
        {getStyleTag(["form-message"])}
        <form
          className={classnames("form--can-load form--onwhite", {
            "state-form-loading": saving
          })}
        >
          <div className="row">
            <div
              className={`small-12 medium-${
                getLayoutType(authenticAccountId) === "type1" ? "5" : "6"
              } columns`}
            >
              <h3 style={getStyles("profile-form__h3")}>
                <FormattedMessage {...profileMessages.myDetails} />
              </h3>
              <label
                className="required"
                style={getStyles("profile-form__label")}
              >
                <FormattedMessage {...profileMessages.displayName} />
              </label>
              {errors.name && (
                <span className="form-message state-error">{errors.name}</span>
              )}
              <input
                name="name"
                className={classnames({ "state-invalid": errors.name })}
                type="text"
                placeholder={intl.formatMessage(
                  profileMessages.displayNameDefault
                )}
                value={values.name}
                onChange={this.inputChange}
                required={true}
                style={getStyles("profile-form__input")}
              />

              <label
                className="required"
                style={getStyles("profile-form__label")}
              >
                <FormattedMessage {...sharedMessages.email} />
              </label>
              {errors.email && (
                <span className="form-message state-error">{errors.email}</span>
              )}
              <input
                name="email"
                className={classnames({ "state-invalid": errors.email })}
                type="text"
                placeholder={intl.formatMessage(sharedMessages.email)}
                value={values.email}
                onChange={this.inputChange}
                required={true}
                style={getStyles("profile-form__input")}
              />
            </div>
            <div
              className={`small-12 medium-${
                getLayoutType(authenticAccountId) === "type1" ? "5" : "6"
              } columns`}
            >
              <h3 style={getStyles("profile-form__h3")}>
                <FormattedMessage {...profileMessages.changePassword} />
              </h3>

              <label style={getStyles("profile-form__label")}>
                <FormattedMessage {...profileMessages.existingPassword} />
              </label>
              {errors.current_password && (
                <span className="form-message state-error">
                  {errors.current_password}
                </span>
              )}
              <input
                type="password"
                className={classnames({
                  "state-invalid": errors.current_password
                })}
                name="current_password"
                onChange={this.inputChange}
                style={getStyles("profile-form__input")}
              />

              <label style={getStyles("profile-form__label")}>
                <FormattedMessage {...profileMessages.newPassword} />
              </label>
              {errors.password && (
                <span className="form-message state-error">
                  {errors.password}
                </span>
              )}
              <input
                type="password"
                className={classnames({ "state-invalid": errors.password })}
                name="password"
                onChange={this.inputChange}
                style={getStyles("profile-form__input")}
              />
              <label style={getStyles("profile-form__label")}>
                <FormattedMessage {...profileMessages.confirmNewPassword} />
              </label>
              <input
                type="password"
                className={classnames({ "state-invalid": errors.password })}
                name="password_confirm"
                onChange={this.inputChange}
                style={getStyles("profile-form__input")}
              />
            </div>
          </div>
          <div
            className="form-actions"
            style={getStyles(["profile-form__form-actions", "form-actions"])}
          >
            {notice && <h4 className={noticeClass}>{notice}</h4>}
            <button
              className={classnames("button button--can-load pull-right", {
                "state-loading": saving
              })}
              type="button"
              onKeyPress={e => {
                if (isKeyClick(e)) this._saveProfile(e)
              }}
              onClick={e => this.saveProfile(e)}
              style={getStyles("profile-form__button")}
            >
              <FormattedMessage {...profileMessages.update} />
            </button>
          </div>
        </form>
      </div>
    )
  }

  inputChange = e => {
    const value = e.target.value
    const field = e.target.getAttribute("name")

    this.setState({
      values: {
        ...this.state.values,
        [field]: value
      }
    })
  }

  saveProfile = e => {
    if (typeof e.preventDefault !== "undefined") e.preventDefault()

    this.setState({ saving: true })
    const { intl } = this.props
    const {
      password,
      current_password,
      password_confirm,
      name,
      email
    } = this.state.values

    if (password && password_confirm !== password) {
      this.setState({
        saving: false,
        errors: {
          password: intl.formatMessage(profileMessages.passwordsDontMatch)
        }
      })
      return
    }

    let values = { name, email, current_password }

    if (password) {
      values = {
        ...values,
        password
      }
    }

    apiAuth("put", "user", values)
      .then(res =>
        this.setState({
          saving: false,
          values: res,
          errors: {},
          notice: intl.formatMessage(profileMessages.profileUpdated),
          noticeClass: "form-message form-message--large state-success"
        })
      )
      .catch(err =>
        new Promise(resolve => {
          if (err.response && err.response.json && !err.response.bodyUsed) {
            err.response.json().then(json => resolve(json.error))
          } else if (err.json && err.json.errors) {
            resolve(err.json)
          } else {
            resolve(err.message)
          }
        }).then(message =>
          this.setState({
            saving: false,
            errors: message.errors || {},
            notice: !message.errors
              ? intl.formatMessage(message.error, {
                  message: message || intl.formatMessage(message.errorCheck)
                })
              : undefined,
            noticeClass: "form-message form-message--large state-error"
          })
        )
      )
  }
}

export default injectIntl(ProfileForm)



// WEBPACK FOOTER //
// ./webapp/components/modules/ProfileForm.js